import { httpService } from '@/services/HttpService';
import { VirtualMachinesList } from '@/interfaces/VirtualMachinesList';

class VirtualMachinesListService {
  getVirtualMachines(workspaceId: number, regionId: number): Promise<VirtualMachinesList> {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/virtual_machines`);
  }
}

export const virtualMachinesListService = new VirtualMachinesListService();
